// $route.query may have important bits like search term on request board
// we want to preserve them when closing modal windows
export const RESERVED_QUERY_PARAMS = [
  'term',
  'page',
  'category',
  'prefix',
  'selectedVacancyId',
  'selectedEmployerId',
  'mrk',
  'query',
];
